import { CreateAccountablePlanData, CreateAccountablePlanParams } from './useCreateAccountablePlan.interface';

import collectiveApi from 'modules/common/collectiveApi';

const createAccountablePlan = async (params: CreateAccountablePlanParams) => {
    const { data } = await collectiveApi.post<CreateAccountablePlanData>('bookkeeping/accountable-plans/', params);
    return data;
};

export default createAccountablePlan;
